import produce from 'immer';

const INITIAL_STATE = {
  profile: null,
  language: null,
  usuarioacesso: [],
  modules: [],
};

export default function user(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@auth/SIGN_IN_SUCCESS': {
        draft.profile = action.payload.user;
        draft.modules = action.payload.modules;
        draft.usuarioacesso = action.payload.usuarioacesso;
        draft.language = action.payload.lang;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.profile = null;
        draft.language = null;
        draft.usuarioacesso = [];        
        draft.modules = [];
        break;
      }
      default:
    }
  });
}
